import { render, staticRenderFns } from "./EmailDraftOrderModal.vue?vue&type=template&id=393b681e&scoped=true&"
import script from "./EmailDraftOrderModal.vue?vue&type=script&lang=js&"
export * from "./EmailDraftOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailDraftOrderModal.vue?vue&type=style&index=0&id=393b681e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b681e",
  null
  
)

export default component.exports